<template>
    <v-container text-center fluid>
        <c-dialog :dialog="alertYn" :message="alertMessage" :yes-text="'OK'" @clickYes="alertYn = false"></c-dialog>
        <div class="text-center">
            <v-dialog v-model="dialogForDelete" width="500">
                <v-card>
                    <v-card-text>
                        Are you sure to clear?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogForDelete = false">
                            No
                        </v-btn>
                        <v-btn text @click="deleteExercise"> Yes </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" width="500">
                <v-card>
                    <v-card-title>
                        <span class="headline">Add New Exercise</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="newExercise" :rules="nameRules" label="Exercise Name" required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="newExerciseMaxWeight" :rules="maxWeightRules" label="1 RM Weight" required></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialog = false">
                            Cancel
                        </v-btn>
                        <v-btn text @click="add">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-data-table
            :headers="headers"
            v-model="selected"
            show-select
            item-key="exercise"
            hide-default-footer
            disable-pagination
            disable-filtering
            :items="listOfWorkout"
            :items-per-page="1000"
            class="elevation-1"
        ></v-data-table>
    </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import global from './../global.js';
import Dialog from './Dialog.vue';

export default {
    name: 'MyWorkout',
    data: () => ({
        alertYn: false,
        alertMessage: null,
        dialog: false,
        dialogForDelete: false,
        newExercise: null,
        newExerciseMaxWeight: 0,
        nameRules: [v => !!v || 'Exercise Name is required'],
        maxWeightRules: [v => !(isNaN(v) || v < 0) || '1 RM Weight must be a positive number'],
        headers: [
            {
                text: 'Exercise',
                align: 'left',
                value: 'exercise',
            },
            {
                text: '1 RM Weight',
                value: 'maxWeight',
            },
        ],
        listOfWorkout: [],
        selected: [],
        user: null,
    }),
    beforeCreate() {
        /**
         * 새로고침 하거나, 브라우저를 껐다가 켜도 세션에서 사용자 정보를 읽어오기 때문에
         * beforeCreate에서 onAuthStateChanged를 등록해준다.
         */
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user;
                this.fetch();
            } else {
                this.user = null;
            }
        });

        global.bus.$on('addMyExercise', () => {
            this.newExercise = '';
            this.newExerciseMaxWeight = 0;
            this.dialog = true;
        });
        global.bus.$on('deleteMyExercise', () => {
            if (this.selected.length > 0) {
                this.dialogForDelete = true;
            }else{
                this.alert('No selected items');
            }
        });
    },
    methods: {
        alert(message){
            this.alertYn = true;
            this.alertMessage = message;
        },
        add() {},
        deleteExercise() {},
        fetch() {
            firebase
                .firestore()
                .collection('user')
                .doc(this.user.uid)
                .collection('exercise')
                .get()
                .then(result => {
                    this.listOfWorkout.length = 0;
                    result.forEach(doc => {
                        this.listOfWorkout.push({
                            exercise: doc.id,
                            maxWeight: doc.data().maxWeight,
                        });
                    });
                });
        },
    },
    components: {
        'c-dialog': Dialog,
    },
};
</script>
